import { StyleSheet, Text, View } from "react-native";
import DashboardBox from "../../base/tamplate/DashboardBox";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';

import ProgressBar from "../component/ProgressBar";
import { FONT } from "../../../value/staticValues";
import { useEffect, useState } from "react";
import { percentValue } from "../../../common/util";

interface SmallProgressBarBoxProps {
    navigate?: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    bottom?: boolean;
    marginBottom?:number;
}

export default function SmallProgressBarBox(props:SmallProgressBarBoxProps) {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        setPercent(percentValue(props.data, props.total));
    }, [props]);

    return (
        <DashboardBox style={{
            width: 160, height: props.bottom? 150 : 160,
            marginRight: 10, marginBottom: props.marginBottom ? props.marginBottom : 0 
        }}>
            <View style={{flexDirection: "row", alignItems: "center", width: "100%", height: 20}}>
                <Text style={{...styles.BoxTitleText, marginRight: "auto"}}>
                    {props.title}
                </Text>
                {props.url && props.navigate?
                    <MoreImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {if(props.navigate) props.navigate(`${props.url}`);}}
                    />
                :null }
            </View>
            <View style={{
                flexDirection: "row", alignItems: "flex-end",
                marginTop: 20, marginBottom: "auto"
            }}>
                <Text style={styles.BigText}>
                    {props.data} 
                </Text>
                <Text style={{...styles.Text, marginBottom: 10, marginLeft: 5}}>
                    Available
                </Text>
            </View>
            <View style={{marginTop: "auto"}}>
                <ProgressBar
                    color={"#0853fb"}
                    percent={percent}
                    total={props.total}
                />
            </View>
        </DashboardBox>
    )
}

const styles = StyleSheet.create({
    BoxTitleText: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        lineHeight: 13,
        color: "#262626"
    },
    Text: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    BigText: {
        fontFamily: FONT.BOLD,
        fontSize: 32,
        color: "#333"
    },
})